import { render, staticRenderFns } from "./savingNotification.vue?vue&type=template&id=5c79f1cf&"
import script from "./savingNotification.vue?vue&type=script&lang=js&"
export * from "./savingNotification.vue?vue&type=script&lang=js&"
import style0 from "./savingNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c79f1cf', component.options)
    } else {
      api.reload('5c79f1cf', component.options)
    }
    module.hot.accept("./savingNotification.vue?vue&type=template&id=5c79f1cf&", function () {
      api.rerender('5c79f1cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/components/savingNotification.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/savingNotification.vue
// module id = 474
// module chunks = 0